import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import { useGetFaxCount } from '@data/faxManagement/hooks/useGetFaxCount';
import { TaskCard } from '../TaskCard/TaskCard';

// Search string appended to /faxmanagement when a user enters the page via
// this task card. The iframe src is built from the parent's location.search
// (see FaxManagementPage), so this flows through to the embedded Fax
// Management app, whose useStatusFilter store reads `?status` from the URL.
const FAXES_WAITING_SEARCH = '?status=WAITING';

export const FaxManagementTaskCard = () => {
	const faxesWaitingCount = useGetFaxCount();
	const history = useHistory();

	const handleClick = React.useCallback(() => {
		history.push({
			pathname: ROUTE_CONSTANTS.FAX_MANAGEMENT,
			search: FAXES_WAITING_SEARCH,
		});
	}, [history]);

	return (
		<TaskCard
			dataField="task-faxesWaitingCount-card"
			label="Faxes Waiting"
			filterLabel="Review all"
			onClick={handleClick}
			tally={faxesWaitingCount}
		/>
	);
};
